import * as z from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { productAndServicesQuerySchema } from './product-services-query-schema';

export const productAndServicesMutationSchema = productAndServicesQuerySchema
  .omit({
    category: true,
    price_frequency: true,
    status: true,
    unit_sell_by: true,
    manufacturer: true,
  })
  .extend({
    category: z.array(z.number()),
    price_frequency: z.array(z.number()),
    unit_sell_by: z.array(z.number()),
    status: statusMutationSchema,
    list_price: z.number(),
    landed_cost: z.number(),
  });

export type ProductAndServicesMutationSchema = z.infer<typeof productAndServicesMutationSchema>;

export const productAndServicesCreateSchema = productAndServicesMutationSchema.pick({
  name: true,
  category_id: true,
  price_frequency_id: true,
  client_opt: true,
});

export type ProductAndServicesCreateSchema = z.infer<typeof productAndServicesCreateSchema>;
